import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTenant } from '../../../../contexts/TenantContext';
import { FooterStatic } from '../../../common/FooterStatic';

const PreviewFooter: React.FC = () => {
  const { isAddEditHost } = useTenant();
  const year = new Date().getFullYear();

  if (!isAddEditHost()) return null;

  return (
    <Box component="footer" sx={{ mt: 'auto' }}>
      {/* Disclaimer — always shown */}
      <Box
        sx={{
          bgcolor: 'secondary.dark',
          color: 'common.white',
          py: 3,
          px: { xs: 2, md: 4 },
          textAlign: 'center',
          '@media print': {
            bgcolor: 'background.paper',
            color: 'text.primary',
            borderTop: '1px solid',
            borderColor: 'text.primary',
          },
        }}
      >
        <Typography variant="body2" sx={{ fontSize: 12, lineHeight: 1.5 }}>
          &copy;{year} Bright MLS, Inc. All Rights Reserved.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: 12,
            lineHeight: 1.5,
            mt: 1,
            maxWidth: 800,
            mx: 'auto',
          }}
        >
          The information included in the Listing Preview is a draft of the
          listing prior to publishing to the MLS. It is deemed reliable, but it
          is presented in order to be independently verified.
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(PreviewFooter);
